<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});

const getPercent = (collected, invoiced) => {
  if (!invoiced) return 0;
  return Math.round((collected / invoiced) * 100);
};

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value || 0);
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5 class="fw-bold mb-1">แนวโน้มรายรับรายเดือน</h5>
          <div class="text-muted small">
            เปรียบเทียบยอดออกบิลกับยอดที่จัดเก็บได้จริง
          </div>
        </div>
        <i class="bi bi-graph-up-arrow text-primary fs-4"></i>
      </div>

      <div class="vstack gap-3">
        <div v-for="item in items" :key="item.month">
          <div class="d-flex justify-content-between small mb-1">
            <span class="fw-semibold">{{ item.month }}</span>
            <span class="text-muted">
              {{ formatCurrency(item.collected) }} /
              {{ formatCurrency(item.invoiced) }}
            </span>
          </div>
          <div class="progress rounded-pill mb-1" style="height: 10px">
            <div
              class="progress-bar bg-primary"
              :style="{
                width: `${getPercent(item.collected, item.invoiced)}%`,
              }"
            ></div>
          </div>
          <div class="small text-muted text-end">
            จัดเก็บได้ {{ getPercent(item.collected, item.invoiced) }}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
